var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inbox mt-2"},[_c('AssetInbox')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }